import { render, staticRenderFns } from "./send-skinny-up.vue?vue&type=template&id=50d8052b&"
import script from "./send-skinny-up.vue?vue&type=script&lang=js&"
export * from "./send-skinny-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d8052b')) {
      api.createRecord('50d8052b', component.options)
    } else {
      api.reload('50d8052b', component.options)
    }
    module.hot.accept("./send-skinny-up.vue?vue&type=template&id=50d8052b&", function () {
      api.rerender('50d8052b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/send-skinny-up.vue"
export default component.exports